import { render } from "./protectTiem.vue?vue&type=template&id=f872a9ec&scoped=true"
import script from "./protectTiem.vue?vue&type=script&lang=js"
export * from "./protectTiem.vue?vue&type=script&lang=js"

import "./protectTiem.vue?vue&type=style&index=0&id=f872a9ec&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f872a9ec"]])

export default __exports__